/* Speed Junkies HQ - Current Giveaway page behaviour.
   Scoped to [data-sjg] nodes only. No external libraries.
   Data source: SpeedjunkiesHQ Manager app proxy. The theme never hard-codes
   giveaway status, dates or multipliers - it only renders a fallback that the
   app data overwrites as soon as it arrives. */
(function () {
  'use strict';
  if (window.__sjGiveawaysInit) return;
  window.__sjGiveawaysInit = true;

  var ALL_URL = '/apps/api/latest-giveaway?all=true';
  var MULT_URL = '/apps/api/current-multiplier';

  function json(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  var recordsPromise = null;
  function records() {
    if (!recordsPromise) {
      recordsPromise = json(ALL_URL).then(function (d) {
        var list = [];
        if (d && Array.isArray(d.giveaways)) list = d.giveaways;
        else if (d) {
          if (d.latestGiveaway) list.push(d.latestGiveaway);
          if (Array.isArray(d.activeGiveaways)) list = list.concat(d.activeGiveaways);
        }
        var byId = {};
        list.forEach(function (g) { if (g && g.id != null) byId[String(g.id)] = g; });
        return byId;
      }).catch(function (e) {
        if (window.console) console.warn('[sj-giveaways] giveaway data unavailable:', e && e.message);
        return {};
      });
    }
    return recordsPromise;
  }

  var multPromise = null;
  function multiplier() {
    if (!multPromise) {
      multPromise = json(MULT_URL).catch(function (e) {
        if (window.console) console.warn('[sj-giveaways] multiplier unavailable:', e && e.message);
        return null;
      });
    }
    return multPromise;
  }

  /* ---- helpers -------------------------------------------------- */

  function toDate(v) {
    if (!v) return null;
    var s = String(v).trim();
    // A bare "YYYY-MM-DDTHH:MM:SS" is read as UTC so every visitor sees the
    // same countdown instead of their own local wall clock.
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(s)) s += 'Z';
    var d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  function esc(s) { return String(s == null ? '' : s); }

  function statusOf(g, now) {
    if (!g) return null;
    var raw = String(g.status || '').toUpperCase();
    var start = toDate(g.start_ts);
    var end = toDate(g.end_ts);
    if (raw !== 'ACTIVE') return 'DRAFT';
    if (end && end.getTime() <= now) return 'ENDED';
    if (start && start.getTime() > now) return 'SCHEDULED';
    return 'LIVE';
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ---- countdown ------------------------------------------------ */

  var clocks = [];
  function registerClock(el) {
    if (!el || el.__sjClock) return;
    el.__sjClock = true;
    clocks.push(el);
  }
  function setEnd(el, iso) {
    if (!el) return;
    if (iso) el.setAttribute('data-sjg-end', iso);
    registerClock(el);
    tick(el);
  }
  function tick(el) {
    var end = toDate(el.getAttribute('data-sjg-end'));
    var out = el.querySelectorAll('[data-sjg-cd]');
    if (!end || !out.length) { return; }
    var diff = Math.max(0, end.getTime() - Date.now());
    var s = Math.floor(diff / 1000);
    var vals = {
      days: Math.floor(s / 86400),
      hours: Math.floor((s % 86400) / 3600),
      mins: Math.floor((s % 3600) / 60),
      secs: s % 60
    };
    for (var i = 0; i < out.length; i++) {
      var k = out[i].getAttribute('data-sjg-cd');
      if (vals[k] == null) continue;
      var txt = k === 'days' ? String(vals[k]) : pad(vals[k]);
      if (out[i].textContent !== txt) out[i].textContent = txt;
    }
    var over = el.closest('[data-sjg-clockwrap]') || el;
    if (diff === 0) over.setAttribute('data-sjg-expired', 'true');
    else over.removeAttribute('data-sjg-expired');
  }
  setInterval(function () { for (var i = 0; i < clocks.length; i++) tick(clocks[i]); }, 1000);

  /* ---- pill ----------------------------------------------------- */

  function paintPill(pill, state) {
    if (!pill) return;
    var map = {
      LIVE: { cls: 'sj-g__pill--live', txt: pill.getAttribute('data-txt-live') || 'Live now' },
      SCHEDULED: { cls: 'sj-g__pill--soon', txt: pill.getAttribute('data-txt-soon') || 'Starting soon' },
      DRAFT: { cls: 'sj-g__pill--soon', txt: pill.getAttribute('data-txt-draft') || 'Coming soon' },
      ENDED: { cls: 'sj-g__pill--ended', txt: pill.getAttribute('data-txt-ended') || 'Closed' }
    };
    var m = map[state] || map.DRAFT;
    pill.classList.remove('sj-g__pill--live', 'sj-g__pill--soon', 'sj-g__pill--ended');
    pill.classList.add(m.cls);
    var label = pill.querySelector('[data-sjg-pill-text]');
    if (label) label.textContent = m.txt;
    pill.setAttribute('data-state', state);
  }

  /* ---- hydration ------------------------------------------------ */

  function field(scope, name) { return scope.querySelector('[data-sjg-field="' + name + '"]'); }

  /* ---- 14 day visual countdown gate -----------------------------
     The clock only renders once this giveaway is within N days of its own
     official end date. Every giveaway on the page is evaluated separately.
     While the clock is gated off we still print the official end date so the
     date itself is never hidden from the customer. */
  function fmtEnd(d) {
    try {
      return d.toLocaleDateString(document.documentElement.lang || 'en-US', {
        year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC'
      });
    } catch (e) { return d.toISOString().slice(0, 10); }
  }

  function applyClockGate(scope, g, state) {
    var wrap = scope.querySelector('[data-sjg-clockwrap]');
    var note = scope.querySelector('[data-sjg-enddate]');
    var end = g ? toDate(g.end_ts) : null;
    var live = state === 'LIVE' || state === 'ENDED';
    var days = wrap ? (wrap.getAttribute('data-sjg-cd-days') || '14') : '14';

    if (!wrap) return;

    if (!live || !end) {
      wrap.removeAttribute('data-sj-cd-gate');
      wrap.hidden = true;
      if (note) { note.removeAttribute('data-sj-cd-gate'); note.hidden = true; }
      return;
    }

    wrap.setAttribute('data-sj-cd-days', days);
    wrap.setAttribute('data-sj-cd-end', String(g.end_ts));
    wrap.setAttribute('data-sj-cd-gate', 'clock');

    if (note) {
      var grid = note.closest('[data-sjg-enddate-prefix]');
      var prefix = grid ? (grid.getAttribute('data-sjg-enddate-prefix') || 'Entries close') : 'Entries close';
      note.textContent = prefix + ' ' + fmtEnd(end);
      note.setAttribute('data-sj-cd-days', days);
      note.setAttribute('data-sj-cd-end', String(g.end_ts));
      note.setAttribute('data-sj-cd-gate', 'pre');
    }

    if (window.SJCountdownGate) {
      window.SJCountdownGate.evaluate(wrap);
      if (note) window.SJCountdownGate.evaluate(note);
    } else {
      /* gate asset missing - fail closed so an early clock never shows */
      wrap.hidden = true;
      if (note) note.hidden = false;
    }
  }

  function hydrate(scope, g) {
    var now = Date.now();
    var state = statusOf(g, now);
    var forced = (scope.getAttribute('data-sjg-force') || '').toUpperCase();
    if (forced && forced !== 'AUTO') state = forced;

    paintPill(scope.querySelector('[data-sjg-pill]'), state || 'DRAFT');

    var live = state === 'LIVE';
    Array.prototype.forEach.call(scope.querySelectorAll('[data-sjg-liveonly]'), function (n) { n.hidden = !live; });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-sjg-notlive]'), function (n) { n.hidden = live; });

    if (!g) return;

    var t = field(scope, 'title');
    if (t && g.title) t.textContent = g.title;

    var p = field(scope, 'prize');
    if (p && g.prize_info) { p.textContent = g.prize_info; p.hidden = false; }

    var d = field(scope, 'description');
    if (d && g.description) { d.textContent = g.description; d.hidden = false; }

    var clock = scope.querySelector('[data-sjg-clock]');
    if (clock && g.end_ts) setEnd(clock, g.end_ts);

    applyClockGate(scope, g, state);

    var epd = field(scope, 'entries_per_dollar');
    if (epd && g.entries_per_dollar) epd.textContent = String(g.entries_per_dollar);

    var eff = field(scope, 'multiplier');
    if (eff && g.effective_multiplier) eff.textContent = String(g.effective_multiplier);

    var rules = scope.querySelector('[data-sjg-rules]');
    if (rules && g.rules_pdf) { rules.setAttribute('href', g.rules_pdf); rules.hidden = false; }

    var gal = scope.querySelector('[data-sjg-gallery]');
    if (gal && Array.isArray(g.images) && g.images.length && gal.getAttribute('data-sjg-gallery') !== 'off') {
      renderGallery(gal, g.images, g.title);
    }
  }

  function renderGallery(gal, images, title) {
    if (gal.__sjDone) return;
    gal.__sjDone = true;
    var max = parseInt(gal.getAttribute('data-max') || '8', 10);
    var frag = document.createDocumentFragment();
    images.slice(0, max).forEach(function (im, i) {
      var src = im && (im.previewUrl || im.url);
      if (!src) return;
      var img = document.createElement('img');
      img.src = src.indexOf('?') > -1 ? src + '&width=600' : src + '?width=600';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 600; img.height = 450;
      img.alt = esc(title) + ' - photo ' + (i + 1);
      frag.appendChild(img);
    });
    if (frag.childNodes.length) { gal.textContent = ''; gal.appendChild(frag); gal.hidden = false; }
  }

  /* ---- boot ----------------------------------------------------- */

  function boot() {
    var scopes = document.querySelectorAll('[data-sjg-id]');
    if (!scopes.length) return;

    // Server-rendered fallback clocks start straight away, no waiting on fetch.
    Array.prototype.forEach.call(document.querySelectorAll('[data-sjg-clock][data-sjg-end]'), setEnd);

    records().then(function (byId) {
      Array.prototype.forEach.call(scopes, function (scope) {
        var id = scope.getAttribute('data-sjg-id');
        hydrate(scope, id && byId[id] ? byId[id] : null);
      });
      document.dispatchEvent(new CustomEvent('sj:giveaways:ready', { detail: { byId: byId } }));
    });

    var multNodes = document.querySelectorAll('[data-sjg-live-multiplier]');
    if (multNodes.length) {
      multiplier().then(function (m) {
        if (!m || !m.success) return;
        Array.prototype.forEach.call(multNodes, function (n) {
          var want = n.getAttribute('data-sjg-live-multiplier');
          if (want === 'label' && m.label) n.textContent = m.label;
          else if (want === 'total' && m.totalMultiplier) n.textContent = String(m.totalMultiplier);
          else if (want === 'base' && m.baseMultiplier) n.textContent = String(m.baseMultiplier);
        });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  // Theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', function () {
    recordsPromise = null; multPromise = null; boot();
  });
})();
